import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeService } from '../../core/services';
import { CONFIG } from '../../config';
import { DateTime } from 'luxon';

@Pipe({
    name: 'crmAge',
    standalone: false
})
export class CrmAgePipe implements PipeTransform {

  transform(value: DateTime | string, short?: boolean): any {
    if (!value) {
      return '-';
    }
    const date = typeof value === 'string' ? DateTimeService.parseDate(value) : value;
    date.toLocal();
    if (this.isToday(date)) {
      return 'Today';
    } else {
      // handle future dates as well
      let age: number = Math.abs(DateTime.now().toMillis() - date.toMillis());
      age = age / 3600000;
      let numVal: number;
      let unit = '';
      if (age < 24) { // If it's less than a day old, show hours
        if (short) {
          return '<1d';
        } else {
          numVal = Math.round(age);
          unit = ' Hour' + (age >= 2 ? 's' : '');
        }
      } else if (age < 720) { // If it's less than a month old, show days
        numVal = Math.round(age / 24);
        unit = short ? 'd' : ' Day';
      } else if (age < 8760) { // If it's less than a year old, show months
        numVal = Math.round(age / 720);
        unit = short ? 'm' : ' Month';
      } else {
        numVal = Math.round(age / 8760);
        unit = short ? 'y' : ' Year';
      }

      if (!short && numVal !== 1 && unit[unit.length - 1] !== 's') {
        unit = unit + 's';
      }

      return numVal + unit;
    }
  }

  private isToday(date: DateTime): boolean {
    const today = DateTime.now();
    return date.day === today.day &&
      date.month === today.month &&
      date.year === today.year;
  }

}
